import { useEffect, useState } from "react";
import api, { apiErrorMessage, formatPLN } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { toast } from "sonner";
import { Save } from "lucide-react";

export default function AdminRules() {
  const [sites, setSites] = useState([]);
  const [drafts, setDrafts] = useState({});

  const load = async () => {
    const s = await api.get("/sites");
    setSites(s.data);
    const d = {};
    s.data.forEach((x) => { d[x.id] = { ...x }; });
    setDrafts(d);
  };

  useEffect(() => { load(); }, []);

  const save = async (id) => {
    try {
      const d = drafts[id];
      await api.patch(`/sites/${id}`, {
        approval_required_for_all_orders: !!d.approval_required_for_all_orders,
        auto_approve_limit: Number(d.auto_approve_limit),
      });
      toast.success("Zaktualizowano reguły");
      load();
    } catch (e) { toast.error(apiErrorMessage(e)); }
  };

  return (
    <div>
      <PageHeader testId="admin-rules" title="Reguły akceptacji" subtitle="Ustaw, kiedy zamówienia trafiają do kierownika" />

      <div className="space-y-4">
        {sites.map((s) => {
          const d = drafts[s.id] || s;
          return (
            <div key={s.id} className="ol-card p-5" data-testid={`rule-${s.id}`}>
              <p className="font-semibold text-slate-900 mb-4">{s.name}</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-start">
                <label className="flex items-start gap-3 cursor-pointer p-3 rounded-md border border-slate-200 hover:border-[#FF6B1A] transition-colors">
                  <input type="checkbox"
                    checked={!!d.approval_required_for_all_orders}
                    onChange={(e) => setDrafts({ ...drafts, [s.id]: { ...d, approval_required_for_all_orders: e.target.checked } })}
                    data-testid={`req-all-${s.id}`}
                    className="mt-0.5 w-4 h-4 accent-[#FF6B1A]" />
                  <div>
                    <p className="text-sm font-semibold text-slate-900">Każde zamówienie wymaga akceptacji kierownika</p>
                    <p className="text-xs text-slate-500 mt-0.5">Wyłącz, aby pozwolić na auto-akceptację małych zamówień.</p>
                  </div>
                </label>

                <div>
                  <label className="block text-xs font-semibold text-slate-700 uppercase tracking-wide mb-1.5">Limit auto-akceptacji</label>
                  <input type="number" step="0.01" disabled={!!d.approval_required_for_all_orders}
                    value={d.auto_approve_limit || 0}
                    onChange={(e) => setDrafts({ ...drafts, [s.id]: { ...d, auto_approve_limit: e.target.value } })}
                    data-testid={`limit-${s.id}`}
                    className="w-full px-3 py-2 rounded-md border border-slate-300 text-sm focus:border-[#FF6B1A] focus:outline-none disabled:bg-slate-50 disabled:text-slate-400" />
                  <p className="text-xs text-slate-500 mt-1">Obecnie: {formatPLN(s.auto_approve_limit)}</p>
                </div>

                <div className="flex md:justify-end">
                  <button onClick={() => save(s.id)} data-testid={`save-rule-${s.id}`}
                    className="inline-flex items-center gap-1.5 px-3 py-2 rounded-md bg-[#FF6B1A] hover:bg-[#E65A10] text-white text-sm font-semibold">
                    <Save className="w-4 h-4" /> Zapisz
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
